<template>
  <div class="feed-content">
    <div class="md-layout">
      <div class="md-layout-item feed-filters-card">
        <feed-filters-menu
            :loggedInUser="this.user"
            @selectionChanged="selectionChange($event)"
            @searchChanged="searchChanged($event)"
            @startDateChanged="startDateChanged($event)"
            @endDateChanged="endDateChanged($event)"
            @selectedFriendsChanged="selectedFriendsChanged($event)"
        >
        </feed-filters-menu>
      </div>
      <list-activity-types class="md-layout-item" v-if="selectedActivityType == 'activities'" @selectedActivityChanged="selectedActivityChanged($event)"></list-activity-types>
    </div>
    <div class="md-layout">
      <div
        v-for="feedItem in feed"
        v-bind:key="feedItem._id"
        class="md-layout-item md-small-size-100 md-size-33"
      >
        <product-card
          card-header="false"
          :cardFooter="hasLength(feedItem.actionButtons)"
          v-if="feedItem.type === ActivityType.Basic"
        >
          <h4 slot="title" class="title" v-html="feedItem.title"></h4>
          <p class="date">{{ formatDate(feedItem.created, true) }}</p>

          <div
            slot="description"
            class="card-description"
            v-html="feedItem.content"
          ></div>

          <div
            slot="footer"
            v-for="button in feedItem.actionButtons"
            v-bind:key="button._id"
          >
            <a :href="button.action"
              ><md-button class="md-primary">{{ button.label }}</md-button></a
            >
          </div>
        </product-card>
        <product-card
          :cardHeader="feedItem.topImage ? 'true' : 'false'"
          :cardFooter="hasLength(feedItem.actionButtons)"
          v-if="feedItem.type === ActivityType.Card"
        >
          <img
            v-if="feedItem.topImage"
            class="img challengeTitleImg"
            slot="imageHeader"
            :src="feedItem.topImage"
          />
          <h4 slot="title" class="title" v-html="feedItem.title"></h4>
          <div slot="date" class="date">
            {{ formatDate(feedItem.created, true) }}
          </div>

          <div
            slot="description"
            class="card-description"
            v-html="feedItem.content"
          ></div>

          <div
            slot="footer"
            v-for="button in feedItem.actionButtons"
            v-bind:key="button._id"
          >
            <a :href="button.action"
              ><md-button class="md-primary">{{ button.label }}</md-button></a
            >
          </div>
        </product-card>
        <!-- ACTIVITY -->
        <md-card v-if="feedItem.type === ActivityType.Activity" class="activity-card">
          <div @click="redirectToActivity(feedItem.activityId)" class="clickable">
            <md-card-header>
              <md-avatar>
                <img
                    v-if="feedItem.userImage"
                    :src="feedItem.userImage"
                    alt="Avatar"
                />
                <img v-else :src="defaultImage" alt="Avatar" />
              </md-avatar>

              <div v-if="feedItem.badges">
                <md-avatar v-for="badge in feedItem.badges" v-bind:key="badge.name"><img :src="badge.icon" :title="badge.name" /></md-avatar>
              </div>

              <div class="md-title">
                <i
                    :class="[
                  { [formatActitivityIcon(feedItem.activityType)]: true }
                ]"
                ></i>
                {{ feedItem.title }}
              </div>
              <p class="date" style="text-align: left;">
                <i v-if="feedItem.externalDataSourceId" class="source">
                  @{{ getSource(feedItem.externalDataSourceId) }}
                </i>
                {{ formatDate(feedItem.start, true) }}
              </p>
            </md-card-header>

            <md-card-media class="md-ratio-4-3" v-if="feedItem.titleImage">
              <img
                  class="img titleImage"
                  :src="feedItem.titleImage"
              />
            </md-card-media>
            <md-card-content>
              <div>
                <ul class="activityData">
                  <li v-if="feedItem.data.distanceInMeters">
                    <div class="name">
                      <i class="far fa-ruler-horizontal"></i> Distanz
                    </div>
                    <b class="value">{{
                        formatM2Km(feedItem.data.distanceInMeters)
                      }}</b>
                  </li>
                  <li v-if="feedItem.durationInSeconds">
                    <div class="name"><i class="far fa-stopwatch"></i> Dauer</div>
                    <b class="value">{{
                        formatS2M(feedItem.durationInSeconds)
                      }}</b>
                  </li>
                  <li
                      v-if="feedItem.data.averageSpeedInMetersPerSecond && feedItem.activityType == 3"
                  >
                    <div class="name">
                      <i class="fal fa-tachometer-fast"></i> Tempo
                    </div>
                    <b class="value">{{
                        formatSpeed(feedItem.data.averageSpeedInMetersPerSecond)
                      }}</b>
                  </li>
                  <li
                      v-if="feedItem.data.averageSpeedInMetersPerSecond && feedItem.activityType != 3"
                  >
                    <div class="name">
                      <i class="fal fa-tachometer-fast"></i> Pace
                    </div>
                    <b class="value">{{
                        formatPace(
                            formatSpeed2Pace(
                                feedItem.data.averageSpeedInMetersPerSecond
                            )
                        )
                      }}</b>
                  </li>

                  <li v-if="feedItem.data.calories">
                    <div class="name"><i class="fal fa-fire"></i> kcal</div>
                    <b class="value">{{ feedItem.data.calories }}</b>
                  </li>

                  <li
                      v-if="feedItem.data.averagePaceInMinutesPerKilometer"
                  >
                    <div class="name">
                      <i class="fal fa-tachometer-fast"></i> Pace
                    </div>
                    <b class="value">{{
                        formatPace(feedItem.data.averagePaceInMinutesPerKilometer)
                      }}</b>
                  </li>

                  <li v-if="feedItem.data.totalElevationGainInMeters">
                    <div class="name"><i class="fal fa-ruler"></i> Anstieg</div>
                    <b class="value">
                      {{ feedItem.data.totalElevationGainInMeters.toFixed(2) }}
                      m</b
                    >
                  </li>
                  <!--
                  <li v-if="feedItem.data.calories">
                    <div class="name">kcal</div>
                    <b class="value">{{ feedItem.data.calories }}</b>
                  </li>
                  <li v-for="(value, name) in feedItem.data" v-bind:key="name">
                    <div class="name">{{ name }}</div>
                    <b class="value">{{ value }}</b>
                  </li>
                  -->
                </ul>
              </div>
            </md-card-content>
          </div>

          <md-card-actions md-alignment="right" class="card-actions">
            <div class="stats" v-if="feedItem.liked">
              {{feedItem.liked.length || 0}}
              <i
              @click="like(feedItem)"
              :class="[
              liked(feedItem) ? 'fas fa-heart' : 'fal fa-heart',
              (likeable(feedItem))?'active':''
              ]"></i>
            </div>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductCard } from "@/components";
import { mapState } from "vuex";
import datetime from "@/utils/datetime";
import activity from "@/utils/activity";
import ListActivityTypes from "sports4me-web_components/atomic-design/atoms/list-activity-types";
import FeedFiltersMenu from "sports4me-web_components/atomic-design/molecules/feed-filters-menu";
import ActivityType from "@/utils/enums/activityTypeEnum";
export default {
  components: {
    ProductCard,
    ListActivityTypes,
    FeedFiltersMenu,
  },
  data() {
    return {
      feed: null,
      defaultImage: "https://images.sports4me.at/img/default-avatar.png",
      activity: {
        images: [],
        activityType: 1,
        data: {
          distanceInMeters: null,
          averagePaceInMinutesPerKilometer: 0,
        }
      },
      showManualActivityDialog: false,
      activityTypes: activity.getActivitiesWithValidData(),
      activityImage: null,
      durationInSeconds: 0,
      distanceInMeters: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      speedInKm: 0,
      ActivityType: ActivityType,
      selectedActivityType: undefined,
      searchValue: undefined,
      searchActivitiesData: {
        me: null,
        friends: [],
        activityTypes: [],
      },
      searchActivitiesBasedOnDate: {
        from: null,
        until: null,
      }
    };
  },
  computed: {
    ...mapState({
      isAdmin: state => state.isAdmin || false,
      user: state => state.user || null
    })
  },
  mounted() {
    this.getFeedFilteredByAllOrNews('all');
  },
  methods: {
    ...datetime,
    ...activity,
    getFeedFilteredByAllOrNews(type, searchValue = '') {
      const url =  type == 'news' ? '/rest/feed/news' : '/rest/feed';
      this.$store
          .dispatch("queryAPI", { url: url, options: { search: searchValue } })
          .then(data => ( this.feed = data ))
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
    },
    getFeedFilteredByActivities(data = {}) {
      let url = '/rest/activity?';

      if (this.searchValue) {
        url = url + 'search=' + this.searchValue + '&';
      }
      if (this.searchActivitiesBasedOnDate.from) {
        url = url + 'from=' + new Date(this.searchActivitiesBasedOnDate.from) + '&';
      }
      if (this.searchActivitiesBasedOnDate.until) {
        url = url + 'until=' + new Date(this.searchActivitiesBasedOnDate.until);
      }

      const body = { url: url, data: data };
      this.$store
          .dispatch("postAPI", {
            url: body.url,
            data: body.data
          })
          .then(res => {
            this.feed = res;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              type: "error",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          });
    },
    hasLength(v) {
      return v ? v.length > 0 : false;
    },
    redirectToActivity(id) {
      this.$store.dispatch("getActivityDetails", id)
          .then(res => {
            this.$router.push("/activity/" + id);
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          })
    },
    formatActitivityIcon: activityType => {
      const icons = {
        1: "far fa-running",
        2: "fas fa-walking",
        3: "far fa-biking",
        4: "far fa-swimmer",
        5: "far fa-dumbbell"
      };
      return icons[activityType] ? icons[activityType] : "fas fa-watch-fitness";
    },
    like(item) {
      if (! (item.activityId && this.likeable(item))) return false;
      this.$store
        .dispatch("queryAPI", {
          url: "/rest/activity/" +
          ((this.liked(item)) ? 'unlike' : 'like') +
          '/' + item.activityId
        })
        .then(res => {
          if (res.success) {
            (this.liked(item)) ? item.liked = item.liked.filter(i => i!=this.user._id) : item.liked.push(this.user._id)
          }
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            type: "error"
          });
        });
    },
    likeable(item) {
      if (item.userId == this.user._id) return false;
      return true
    },
    liked(item) {
      if (item.liked.includes(this.user._id)) return true;
      return false
    },
    selectionChange(type) {
      this.selectedActivityType = type;
      if (type == 'activities') {
        this.getFeedFilteredByActivities(this.searchActivitiesData)
      } else {
        this.getFeedFilteredByAllOrNews(type, this.searchValue);
      }
    },
    searchChanged(searchVal) {
      this.searchValue = searchVal;
      if (this.selectedActivityType = 'activities') {
        this.getFeedFilteredByActivities(this.searchActivitiesData)
      } else {
        this.getFeedFilteredByAllOrNews(this.selectedActivityType, searchVal);
      }
    },
    startDateChanged(date) {
      this.searchActivitiesBasedOnDate.from = date;
      this.getFeedFilteredByActivities(this.searchActivitiesData)
    },
    endDateChanged(date) {
      this.searchActivitiesBasedOnDate.until = date;
      this.getFeedFilteredByActivities(this.searchActivitiesData)
    },
    selectedActivityChanged(activities) {
      this.searchActivitiesData.activityTypes = activities;
      this.getFeedFilteredByActivities(this.searchActivitiesData)
    },
    selectedFriendsChanged({friendsList, me}) {
      this.searchActivitiesData.friends = friendsList;
      this.searchActivitiesData.me = me;
      this.getFeedFilteredByActivities(this.searchActivitiesData)
    }
  }
};
</script>

<style lang="scss" scoped>
.active {
  color: #F63C4C;
}
.activity-card .clickable {
  cursor: pointer;
}
div.activity-card div.md-card-content {
  padding-top: 0;
}
ul.activityData {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
ul.activityData > li {
  margin-left: 0;
  margin-right: 12px;
  padding-right: 12px;
  position: relative;
  margin-bottom: 0.75em;
}
ul.activityData > li:after {
  content: "";
  display: block;
  border-right: 1px solid #f0f0f5;
  height: 24px;
  width: 1px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -12px;
}
li > div.name {
  font-size: 12px;
  font-weight: 400;
  color: #494950;
  line-height: 1.2;
}
.card-actions {
 justify-content: space-between;
}

.titleImage {
  border-radius: 6px;
  margin-bottom: 10px;
}
.feed-filters-card {
  z-index: 3;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
</style>
